// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"557":"59e08c07","883":"40a9a32d"}[chunkId] + ".js";
};